// extracted by mini-css-extract-plugin
module.exports = {"root":"_2mp93","portraits":"_38yYs","border":"_2hywP","company":"_2T3WP","firstline":"_2KvXp","header":"_1hCAV","founders":"_2XfXc","alignRight":"_3P-3i","email":"iyk_a"};